import React, { ReactNode, useContext } from "react";
import { MultiCodeBlockContext } from "@apollo/chakra-helpers";

export function ConditionalText({
  language,
  children,
}: {
  language: string;
  children: ReactNode;
}) {
  const codeBlockContext = useContext(MultiCodeBlockContext);
  return (
    <>
      {language.toLowerCase() === codeBlockContext.language?.toLowerCase()
        ? children
        : null}
    </>
  );
}
